var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99996 2.02439C4.77416 2.02439 3.78045 3.0181 3.78045 4.2439V7.14634H9.41459C10.4518 7.14634 11.2926 7.98717 11.2926 9.02439V13.122C11.2926 14.1592 10.4518 15 9.41459 15H2.58532C1.54811 15 0.707275 14.1592 0.707275 13.122V9.02439C0.707275 7.98717 1.54811 7.14634 2.58532 7.14634H2.75606V4.2439C2.75606 2.45234 4.2084 1 5.99996 1C7.79152 1 9.24386 2.45234 9.24386 4.2439C9.24386 4.52678 9.01454 4.7561 8.73166 4.7561C8.44879 4.7561 8.21947 4.52678 8.21947 4.2439C8.21947 3.0181 7.22576 2.02439 5.99996 2.02439ZM2.58532 8.17073C2.11386 8.17073 1.73167 8.55293 1.73167 9.02439V13.122C1.73167 13.5934 2.11386 13.9756 2.58532 13.9756H9.41459C9.88605 13.9756 10.2683 13.5934 10.2683 13.122V9.02439C10.2683 8.55293 9.88605 8.17073 9.41459 8.17073H2.58532ZM5.99996 10.9024C5.90567 10.9024 5.82923 10.9789 5.82923 11.0732C5.82923 11.1675 5.90567 11.2439 5.99996 11.2439C6.09425 11.2439 6.17069 11.1675 6.17069 11.0732C6.17069 10.9789 6.09425 10.9024 5.99996 10.9024ZM4.80484 11.0732C4.80484 10.4131 5.33991 9.87805 5.99996 9.87805C6.66001 9.87805 7.19508 10.4131 7.19508 11.0732C7.19508 11.7332 6.66001 12.2683 5.99996 12.2683C5.33991 12.2683 4.80484 11.7332 4.80484 11.0732Z",
    fill: "#7043FF",
    stroke: "#7043FF",
    strokeWidth: 0.406926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLock);
export default __webpack_public_path__ + "static/media/open_lock.819253d681e0d2c6e47ebfe7da5ccd49.svg";
export { ForwardRef as ReactComponent };